import React, { useState } from "react";
import { APP_DOMAIN } from "../../constants/constants";
const ErrorBoxMobile = (props) =>{
    const [isOpen, setIsOpen] = useState(true);
    const handleToggle = () => {
        setIsOpen(!isOpen);
    };
    return  <div className="d-flex-column error-box" >
                <div className="e-head">
                    <div className="e-exclamation">
                        <div className={`e-circle ${props?.success ? 'bg-success' : 'bg-error'}`}></div>
                    </div>
                    <h3>{props.message}</h3>
                    <span className="toggleIcon" onClick={handleToggle}>
                        {isOpen ? <i className="icon-arrow-up-light"></i> : <i className="icon-arrow-down-light"></i>}
                    </span>
                </div>
                {isOpen && (
                    <div className='e-body'>
                        <span>{props.description}</span>
                        <div className="action-item">
                            {props?.hide_ignore_button ||<div className="btn-ignore" onClick={() => props?.ignoreSuggestion && props.ignoreSuggestion()}>
                                <img src={`${APP_DOMAIN}/assets/images/x-mark.svg`} />
                                <span >Ignore</span>
                            </div>}
                            {props?.hide_view_button || <div className="view-btn" data-suggestion-id={props.element_id ? props.element_id : null} onClick={() => props?.scrollToErrorField && props.scrollToErrorField() }><span>View</span></div>}
                        </div>
                    </div>
                )}
        </div>

}
export default ErrorBoxMobile;